import * as React from 'react'
import { DateRangePicker } from 'react-dates'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import { FormattedNumber } from 'react-intl'
import { PageLoader } from '../shared/loaders/PageLoader'
import { exportToCsv } from './taxesApi'
import { LayoutProps, valueOrNull } from './taxesState'
import { Moment } from 'moment';

export const TaxesOverviewLayout = (props: LayoutProps): JSX.Element => (
  <section className="page-section page-section--slim">
    <header className="grid-100 page-section__head">
      <h1 className="page-section__title">
        {I18n.t('superadmin.taxes.overview_title')}
      </h1>
    </header>

    <div className="grid-50">
      <div className="box datepicker--bordered">
        <DateRangePicker
          startDate={valueOrNull(props.state.dateRangeState.startDate)}
          startDateId="start_date_id"
          startDatePlaceholderText={I18n.t('superadmin.taxes.from')}
          endDate={valueOrNull(props.state.dateRangeState.endDate)}
          endDateId="end_date_id"
          endDatePlaceholderText={I18n.t('superadmin.taxes.to')}
          onDatesChange={range => props.chooseRange(range)}
          focusedInput={valueOrNull(props.state.dateRangeState.focus)}
          onFocusChange={focusedInput => props.chooseFocus(focusedInput)}
          isOutsideRange={_ => false}
          renderDay={(day: Moment) => <div className={'CalendarDay_button__contents'}>{day.date()}</div>}
          numberOfMonths={1}
          orientation={window.innerWidth <= 768 ? 'vertical' : 'horizontal'}
          withFullScreenPortal={window.innerWidth <= 768}
        />
      </div>
    </div>

    {props.state.overview.kind === 'loaded' ? (
      <div className="grid-100 table-wrapper">
        <button
          className="btn btn--primary"
          onClick={_ =>
            exportToCsv(
              props.state.overview.kind === 'loaded'
                ? props.state.overview.value
                : []
            )
          }
        >
          {I18n.t('superadmin.taxes.export')}
        </button>
        <table className="table--bordered index table--zebra">
          <thead>
            <tr>
              <th>{I18n.t('superadmin.taxes.entity')}</th>
              <th>{I18n.t('superadmin.taxes.value')}</th>
            </tr>
          </thead>
          <tbody>
            {props.state.overview.value.map(ct => (
              <tr key={ct.collective_external_id + ct.collective_name}>
                <td>{`${ct.collective_name} (${ct.collective_external_id})`}</td>
                <td>
                  <FormattedNumber
                    value={ct.tariff_value}
                    style="currency"
                    currency="EUR"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : props.state.overview.kind === 'loading' ? (
      <PageLoader />
    ) : (
      <></>
    )}
  </section>
)
